import React from 'react';
import AlertPaymentExisting9sView from './alert-payment-existing-9s-view';


const AlertPaymentExisting9sContainer = () => (<AlertPaymentExisting9sView />);

export default AlertPaymentExisting9sContainer;
